import { BASE_URL } from '../BASE_URL';

export const getNew = async (id) => {
  const response = await fetch(BASE_URL + `news/${id}`, {
    method: 'GET',
  });
  const data = await response.json();
  return data;
};
